import { render, staticRenderFns } from "./RemoveMemberModal.vue?vue&type=template&id=a8af9c0c&"
import script from "./RemoveMemberModal.vue?vue&type=script&lang=js&"
export * from "./RemoveMemberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports